// 视频悬停控制器 - 优化版
class VideoHoverFixed {
  constructor() {
    this.items = [];
    this.hoverTimeouts = new Map();
    this.init();
  }

  init() {
    console.log('🎬 初始化视频悬停（优化版）');
    this.setupImmediate();
    this.observeDOM();
  }

  setupImmediate() {
    this.items = document.querySelectorAll('.video-item[data-has-video="true"]');
    console.log(`📊 找到 ${this.items.length} 个带视频的项目`);
    
    this.items.forEach((item, index) => {
      this.setupItem(item, index);
    });
  }

  setupItem(item, index) {
    const video = item.querySelector('.product-video');
    const image = item.querySelector('.product-image');
    
    if (!video || !image) return;
    
    console.log(`✅ 设置项目 ${index + 1}`);
    
    // 确保视频属性
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    
    // 添加事件监听
    this.addHoverEvents(item, video);
    
    // 监听图片加载完成
    if (image.complete) {
      // 图片已加载
    } else {
      image.addEventListener('load', () => {
        // 图片加载完成后
      });
    }
  }

  addHoverEvents(item, video) {
    let hoverTimer;
    let isHovering = false;
    let isTouching = false;
    
    // 鼠标进入
    item.addEventListener('mouseenter', () => {
      if (isTouching) return;
      clearTimeout(hoverTimer);
      
      hoverTimer = setTimeout(() => {
        if (isHovering) return;
        isHovering = true;
        
        this.playVideo(item, video);
      }, 100);
    });
    
    // 鼠标离开
    item.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
      
      hoverTimer = setTimeout(() => {
        if (!isTouching) {
          isHovering = false;
          this.stopVideo(item, video);
        }
      }, 100);
    });
    
    // 触摸事件
    item.addEventListener('touchstart', (e) => {
      e.preventDefault();
      isTouching = true;
      
      if (item.classList.contains('video-hover')) {
        this.stopVideo(item, video);
      } else {
        this.playVideo(item, video);
      }
      
      // 防止触摸滚动
      setTimeout(() => {
        isTouching = false;
      }, 300);
    }, { passive: false });
    
    this.hoverTimeouts.set(item, hoverTimer);
  }

  async playVideo(item, video) {
    console.log('▶️ 播放视频');
    
    // 添加悬停类
    item.classList.add('video-hover');
    
    // 如果视频还没加载，先加载
    if (video.readyState < 2) {
      video.load();
      
      try {
        await new Promise((resolve) => {
          const onCanPlay = () => {
            video.removeEventListener('canplay', onCanPlay);
            resolve();
          };
          
          video.addEventListener('canplay', onCanPlay);
          
          // 3秒超时
          setTimeout(() => {
            video.removeEventListener('canplay', onCanPlay);
            resolve();
          }, 3000);
        });
      } catch (e) {
        console.log('⏱️ 视频加载超时');
      }
    }
    
    // 播放视频
    try {
      video.currentTime = 0;
      await video.play();
    } catch (error) {
      console.log('⚠️ 播放失败，尝试静音播放');
      video.muted = true;
      try {
        await video.play();
      } catch (e) {
        console.log('❌ 静音播放也失败');
      }
    }
  }

  stopVideo(item, video) {
    console.log('⏸️ 停止视频');
    
    item.classList.remove('video-hover');
    video.pause();
    video.currentTime = 0;
  }

  observeDOM() {
    if (!('MutationObserver' in window)) return;
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('video-item')) {
            this.setupItem(node);
            this.items = document.querySelectorAll('.video-item[data-has-video="true"]');
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// ========== 初始化 ==========
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 DOM加载完成，启动视频悬停');
  
  // 创建控制器实例
  window.videoHover = new VideoHoverFixed();
  
  // 页面隐藏时暂停所有视频
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      document.querySelectorAll('.video-item').forEach(item => {
        item.classList.remove('video-hover');
        const video = item.querySelector('.product-video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    }
  });
});